import { render, staticRenderFns } from "./SiteBasic.vue?vue&type=template&id=2e4240c7&scoped=true"
import script from "./SiteBasic.vue?vue&type=script&lang=js"
export * from "./SiteBasic.vue?vue&type=script&lang=js"
import style0 from "./SiteBasic.vue?vue&type=style&index=0&id=2e4240c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4240c7",
  null
  
)

export default component.exports